import React from 'react'
import PropTypes from 'prop-types'
import { useHistory } from 'react-router-dom'

import Button from '../../../components/button'
import { BROWSE_NEON } from '../../../constants'
import styles from './preview-import-list-not-found.css'

function PreviewImportListNotFound({ description }) {
  const history = useHistory()

  return (
    <div className={styles.container}>
      <div className={styles.content}>
        <div className={styles.title}>
          We couldn’t find that list
        </div>
        {description && (
          <div className={styles.description}>
            {description}
          </div>
        )}
        <Button
          wrapperClassName={styles.buttonWrapper}
          text={BROWSE_NEON.label}
          onClick={() => history.push(BROWSE_NEON.url)}
        />
      </div>
    </div>
  )
}

PreviewImportListNotFound.propTypes = {
  description: PropTypes.string
}

PreviewImportListNotFound.defaultProps = {
  description: ''
}

export default PreviewImportListNotFound
